import {PlayerProfileEvent} from './player-profile-event';
import {PlayerProfileEventMatch} from './player-profile-event-match';
import {TranslateService} from '@ngx-translate/core';

export class CalendarItemEvent
{
  date: Date;
  name: string;
  type: string;

  street: string;
  postalCode: string;
  city: string;
  countryCd: string;
  playingVenue: string;

  eventYear: number;
  eventMonth: number;
  eventDay: number;

  event: PlayerProfileEvent;
  match: PlayerProfileEventMatch;

  public static initData(data: CalendarItemEvent, translate: TranslateService): void
  {
    if (data)
    {
      if (data.date)
      {
        data.date = new Date(data.date);

        data.eventYear = data.date.getFullYear();
        data.eventMonth = data.date.getMonth();
        data.eventDay = data.date.getDate();
      }

      if (data.event)
      {
        PlayerProfileEvent.initData(data.event);
        data.type = translate.instant('TOURNAMENT');
      }
      if (data.match)
      {
        PlayerProfileEventMatch.initData(data.match);
        data.type = translate.instant('LEAGUE');
      }
    }
  }
}
